module.exports = __webpack_public_path__ + "img/fb16261.jpg";